/* file description */
/* file description */

import { GetRecordListByParams } from './type';

/**
 * @desc 请求列表模型数据的方法
 * @param param0 GetRecordListByParams
 * @returns 数据～
 */
export const getRecordListByParams: GetRecordListByParams = async ({ params, ComposeAPI }) => {
  const result = (await ComposeAPI!.recordList({
    ...params,
    incPageNavigation: params.incPageNavigation,
    incTotal: params.incTotal,
    deleted: 0,
  })) as {
    set: Array<{
      values: Array<{ name: string; value: any; isPrimary: boolean }>;
      [k: string]: any;
    }>;
    filter: Record<any, any>;
  };
  return result;
};
